'use client';

import React from 'react';
import Image from 'next/image';
import { StyledWidgetHero } from './widgetExamples.styles';
import { IPlatform, IPlugin } from '../../types';
import { WidgetNavbar } from '../widgetNavbar/widgetNavbar.comp';
import { Button } from '../button/button.comp';
import { Header } from '../header/header.comp';
import { CommonNinjaWidgetRenderer } from '../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp';

interface IWidgetExamplesProps {
	widget: IPlugin;
	platform?: IPlatform;
}

export const WidgetExamples = ({ widget, platform }: IWidgetExamplesProps) => {
	const name = `${widget.name} Examples${platform?.title ? ` for ${platform.title}` : ''}`;

	function renderExample(example: IPlugin['examples'][0]) {
		return (
			<div
				key={`example ${example.title}-${example.text}`}
				className={`example top-to-bottom`}
			>
				{example.pluginId && (!example.buttonText && !example.buttonClass) ?
					// It's not a popup, showing borowser mock
					<div className="browser-mock">
						<div className="browser-bar">
							<div className="dots">
								<div className="dot"></div>
								<div className="dot"></div>
								<div className="dot"></div>
							</div>
						</div>
						<div className="html">
							<CommonNinjaWidgetRenderer widgetId={example.pluginId} />
						</div>
					</div>
					:
					<>
						{example.imgUrl &&
							<Image
								width={1200}
								height={675}
								className="example-image"
								src={example.imgUrl}
								alt={`${example.title} example`}
							/>
						}
					</>
				}

				<div className="example-details">
					<h2>{example.title}</h2>
					<p>{example.text}</p>
					{example.pluginId && example.buttonText && example.buttonClass &&
						// Have to be popup
						<>
							<Button className={example.buttonClass}>
								{example.buttonText}
							</Button>
							<CommonNinjaWidgetRenderer widgetId={example.pluginId} />
						</>
					}
				</div>
			</div>
		);
	}

	return (
		<>
			<StyledWidgetHero>
				<section className="hero">
					<Header
						fixedPosition={true}
						style={{ background: 'transparent', paddingRight: '0', paddingLeft: '0' }}
					/>
					<WidgetNavbar widget={widget} platform={platform} />
					<div className="hero-wrapper">
						{platform?.icon && (
							<div className="platform-img-wrapper">
								<Image src={platform.icon} alt={platform.title} fill />
							</div>
						)}
						<h1>{name}</h1>
						<h2>
							Check out our {widget.name} examples and discover the full
							potential of the widget!
						</h2>
					</div>
				</section>
				{widget?.examples.length > 0 && (
					<section className="examples-section">
						<div className="examples-content-wrapper">
							{widget.examples.map((example) => renderExample(example))}
						</div>
					</section>
				)}
			</StyledWidgetHero>
		</>
	);
};
